import { Button, Flex, Text } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getErrorMessage } from './errorMessage';

/** エラー画面を表示してから、自動でトップに戻るまでの秒数 */
export const AUTO_BACK_TO_TOP_SECONDS = 30;

/**
 * エラー画面(`/error?errorCode=...`)。ログイン前後のどちらでも表示できる。
 * トップ(`/`)は、ログイン済みなら `/top`、未ログインならサインインへ遷移する。
 * エラーの状態を残さないよう、ページを読み込み直して戻る。
 */
export default function ErrorScreen() {
  const { search } = useLocation();
  const errorCode = new URLSearchParams(search).get('errorCode') ?? '';
  const goTop = () => {
    window.location.href = '/';
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = '/';
    }, AUTO_BACK_TO_TOP_SECONDS * 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Flex direction="column" align="center" justify="center" textAlign="center" minH="60vh" gap={3} role="alert">
      <Text fontSize="xl" fontWeight="bold">
        {getErrorMessage(errorCode)}
      </Text>
      {errorCode && <Text color="gray.600">ERROR_CODE: {errorCode}</Text>}
      <Text color="gray.600">{AUTO_BACK_TO_TOP_SECONDS}秒後にトップに戻ります。</Text>
      <Button colorScheme="blue" onClick={goTop}>
        TOPへ戻る
      </Button>
    </Flex>
  );
}
